import { getAppViewDevice } from '../../render/util/app-view-utils';
import MetricsRegistry from '../metrics-registry';

class SyiMetrics extends MetricsRegistry {
    registerPageViewEvent(postAdPageType, appViewDevice) {
        this.registerClientSideEvent('pageview', { postAdPageType, appViewDevice });
    }

    registerDraftModalEvent(
        draftModalStatus: 'accepted' | 'cancelled' | 'displayed',
        appViewDevice: ReturnType<typeof getAppViewDevice>
    ) {
        this.registerClientSideEvent('draft_modal', {
            draftModalStatus,
            appViewDevice,
        });
    }

    registerImageUploadEvent(
        uploadStatus: 'success' | 'fail',
        categoryId: number,
        appViewDevice: ReturnType<typeof getAppViewDevice>
    ) {
        this.registerClientSideEvent('image_upload', { uploadStatus, categoryId, appViewDevice });
    }

    getModuleName() {
        return 'syi';
    }

    getCountersToRegister() {
        return [
            { name: 'pageview', labelNames: ['postAdPageType', 'appViewDevice'] },
            { name: 'draft_modal', labelNames: ['draftModalStatus', 'appViewDevice'] },
            { name: 'image_upload', labelNames: ['uploadStatus', 'categoryId', 'appViewDevice'] },
        ];
    }

    getHistogramsToRegister() {
        return [];
    }
}

export default new SyiMetrics();
